namespace e5.ScrollViewScale {
    class ScrollViewScaleCover implements IScrollViewScale {
        public getScale(view: ScrollView): number {
            var scX = view.width / view.contentWidth;
            var scY = view.height / view.contentHeight;
            return Math.max(scX, scY);
        }
    }

    export const Cover = new ScrollViewScaleCover();
}